<template>
  <div>
    <v-form ref="bookingConfirmationForm" @submit.prevent="">
      <v-row class="no-gutters">
        <v-col class="col-4">
          <v-row>
            <!-- waiting list -->
            <v-col class="col-12 pt-0">
              <v-card outlined>
                <v-card-title>
                  {{ $t('shopBackendBookingOverview.bookingState') }}
                </v-card-title>
                <v-card-text>
                  <v-select
                    :value="bookingStates.getBookingState()"
                    :items="
                      bookingStates.getBookingStates(
                        definitions.bookingState.auto_confirmed
                      )
                    "
                    :label="$t('shopBackendBookingOverview.bookingState')"
                    item-text="title"
                    item-value="state"
                    outlined
                    :rules="[
                      (v) =>
                        !!v || $t('bookingConfirmation.bookingStateMandatory'),
                    ]"
                    @change="
                      (v) => {
                        bookingStates.setBookingState(v)
                      }
                    "
                  />
                </v-card-text>
              </v-card>
            </v-col>

            <!-- notes / remarks -->
            <v-col class="col-12">
              <v-card outlined>
                <v-card-title>
                  {{ $t('bookingConfirmation.internalRemark') }}
                </v-card-title>
                <v-card-text>
                  <v-textarea
                    v-model="note"
                    :label="$t('shopBackendBookingDetail.remark')"
                    :rows="6"
                    auto-grow
                    outlined
                    :counter="240"
                    :rules="[
                      (v) =>
                        !v || v.length <= 240 || $t('shopComment.maxCharacter'),
                    ]"
                  />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <!-- mail text -->
        <v-col class="col-8">
          <v-card outlined>
            <v-card-title class="pb-0">
              <v-row>
                <v-col class="col-11 pt-0">
                  <span v-if="sendMail">
                    {{ $t('bookingConfirmation.sendMail') }}
                  </span>

                  <!-- do not send any confirmation mail -->
                  <span v-else>
                    {{ $t('bookingConfirmation.doNotSendMail') }}
                  </span>
                </v-col>

                <!-- switch -->
                <v-col class="col-1 pa-0 text-right mt-n4">
                  <v-switch v-model="sendMail" color="primary" />
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text v-show="sendMail">
              <!-- user to send mail confirmation -->
              <v-row v-if="user">
                <v-col class="col-12 pt-0 content-3">
                  <span class="fal fa-envelope mr-2" />{{ user.getMail() }} ({{
                    user.getFullName()
                  }})
                </v-col>
              </v-row>

              <!-- mail text -->
              <v-row>
                <v-col class="col-12">
                  <mail-compose
                    ref="mailCompose"
                    :user="user"
                    :basket="basket"
                    :booking-states="bookingStates"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>


<script>
import User from '../../../classes-shared/user/User'
import UserBookings from '../../../classes-shared/bookings/UserBookings'
import Basket from '../../../classes-shared/basket/Basket'
import BookingStates from '../../../classes-shared/bookings/BookingStates'
import definitions from '../../../../definitions'
import MailCompose from './MailCompose'
import _ from 'lodash'

export default {
  name: 'BookingConfirmation',
  components: { MailCompose },

  props: {
    // Type: User
    // To compose the mail
    user: {
      type: [User, UserBookings],
      required: true,
    },

    // Type: Basket
    basket: {
      type: Basket,
      required: true,
    },

    bookingStates: {
      type: BookingStates,
      required: true,
    },
  },

  data() {
    return {
      // Type: HH:MM
      time: null,
      note: null,

      // do we send any mail?
      sendMail: true,

      // helper
      definitions,
    }
  },

  computed: {
    users() {
      if (this.basket) {
        let basketEntries = this.basket.getBasketEntries()
        if (!basketEntries.length) return []
        let uniqueBasketEntries = _.uniqBy(basketEntries, (basketEntry) => {
          return basketEntry.getUserData().getUid()
        })
        return uniqueBasketEntries.map((basketEntry) =>
          basketEntry.getUserData().getUser()
        )
      }
      return []
    },
  },

  methods: {
    // validate all forms
    // called from parent component
    validate() {
      const mailTextState = this.$refs.mailCompose.validate()
      return (
        this.$refs.bookingConfirmationForm.validate() &&
        (mailTextState || !this.sendMail)
      )
    },

    // GETTERS for parent components
    getMailText() {
      return this.$refs.mailCompose.getMailText()
    },

    getNote() {
      return this.note
    },

    // used by parent components
    getSendMail() {
      return this.sendMail
    },
  },
}
</script>
